<template>
  <div class="addtocart">
    <modal ref="modal" full-header :hide-footer="true">
      <template slot="header"></template>
      <template slot="body">
        <div class="container-fluid pitem-details">
          <h3 class="pt-2">{{ $t('message.becomeMember') }}</h3>
          <p>{{ $t('message.fasterCheckoutManageOrdersEarnPoints') }}</p>
        </div>
        <div class="container-fluid pitem-details">
          <button
            type="button"
            :style="desktopStyles.btn"
            class="btn btn-primery"
            @click="placeOrder()"
          >{{ $t('message.skip') }}</button>
          <button
            type="button"
            :style="desktopStyles.btn"
            class="btn btn-primery btn-with-margins"
            @click="setRegisterNewUserState()"
          >{{ $t('message.becomeMember') }}</button>
        </div>
      </template>
      <template slot="footer"></template>
    </modal>
  </div>
</template>

<script>
import modal from "./../../modal.vue";

import { mapGetters } from "vuex";
export default {
  components: { modal },
  computed: {
    ...mapGetters(["desktopStyles"])
  },
  methods: {
    placeOrder() {
      this.$emit("setBecomeMemberResult", false);
    },
    setRegisterNewUserState() {
      this.$emit("setBecomeMemberResult", true);
    },
    closeModal() {
      this.$refs.modal.hideModal();
    }
  }
};
</script>